import React from 'react'
import { Tooltip } from 'components/common/Tooltip'

type Props = {
  title?: string
  children?: React.ReactNode
  className?: string
  hideTitle?: boolean
  toolTip?: string
}

export const ArtworkDetail = ({
  title,
  children,
  className,
  hideTitle = false,
  toolTip,
}: Props) => {
  return (
    <div className={className}>
      {!hideTitle && (
        <div className='flex items-center'>
          <span className='text-cool-600'>{title}</span>
          {toolTip && (
            <span className='ml-2'>
              <Tooltip content={toolTip} />
            </span>
          )}
        </div>
      )}
      {children}
    </div>
  )
}
